export var ChatMessageType;
(function (ChatMessageType) {
    ChatMessageType[ChatMessageType["USER"] = 100] = "USER";
    ChatMessageType[ChatMessageType["AGENT"] = 110] = "AGENT";
    ChatMessageType[ChatMessageType["INTERNAL"] = 120] = "INTERNAL";
})(ChatMessageType || (ChatMessageType = {}));
export var ChatMessageStatus;
(function (ChatMessageStatus) {
    ChatMessageStatus[ChatMessageStatus["QUEUED"] = 10] = "QUEUED";
    ChatMessageStatus[ChatMessageStatus["FAILED"] = 20] = "FAILED";
    ChatMessageStatus[ChatMessageStatus["SENT"] = 30] = "SENT";
    ChatMessageStatus[ChatMessageStatus["DELIVERED"] = 40] = "DELIVERED";
    ChatMessageStatus[ChatMessageStatus["READ"] = 50] = "READ";
})(ChatMessageStatus || (ChatMessageStatus = {}));
//# sourceMappingURL=chat-message.i.js.map